module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-related"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "search-related-topics"
  }, _vm._l((_vm.relatedSearches), function(topic) {
    return _c('div', {
      key: topic.name,
      staticClass: "search-related-topic"
    }, [_c('div', {
      staticClass: "search-related-topic-title"
    }, [_c('h4', [_vm._v("By " + _vm._s(topic.name))])]), _vm._v(" "), _c('div', {
      staticClass: "search-related-topic-links"
    }, _vm._l((topic.clusters), function(cluster) {
      return _c('div', {
        staticClass: "search-related-topic-link"
      }, [_c('button', {
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.searchRelated(cluster)
          }
        }
      }, [_vm._v("\n            " + _vm._s(cluster.label) + "\n          ")])])
    }))])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-related-title"
  }, [_c('h3', [_vm._v("Related Searches")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-120dca91","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=8hbdlddx288!./~/string-replace-webpack-plugin/loader.js?id=ayyc1bnkec!./src/components/search/searchRelated.vue
// module id = 394
// module chunks = 1